import Footer from './Footer'
import Header from './Header'
import { RolexPageTypeTracking } from './PageTypeTracking'
import { Footer as GassanFooter, Header as GassanHeader } from '@components/Page'
import { FC } from 'react'

export type RolexPageTypes =
  | 'home page'
  | 'collection page'
  | 'family page'
  | 'model page'
  | 'rolex at page'
  | 'history page'
  | 'team page'
  | 'showroom page'
  | 'servicing your rolex page'
  | 'servicing procedure page'
  | 'contact page'
  | 'store contact page'
  | 'watchmaking page'
  | 'article hub page'
  | 'article page'
  | 'contact form page'
  | 'book an appointment page'
  | 'All New Watches 2025 Family pages'
  | 'New Watches 2025'

export type RolexPageProps = {
  pageType?: RolexPageTypes
  productFamily?: string
  productRMC?: string
}

const RolexPage: FC<RolexPageProps> = ({ children, ...props }) => {
  return (
    <>
      {props.pageType && <RolexPageTypeTracking {...props} />}
      <GassanHeader initialVariant="absolute" />
      <div className="mx-auto w-full max-w-[109rem]">
        <Header />
        {children}
        <Footer />
      </div>
      <GassanFooter />
    </>
  )
}
export default RolexPage
